/* Test «¿De qué te estás escapando?» — comportamiento. Los textos están en data.js (window.TEST). */
(function () {
  "use strict";
  const T = window.TEST;
  const raiz = document.querySelector(".test-escapando");
  if (!T || !raiz) return;

  const $ = (sel, el) => (el || raiz).querySelector(sel);
  const el = (tag, cls, texto) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (texto != null) n.textContent = texto;
    return n;
  };

  // Estado: solo en memoria. Recargar reinicia el test.
  const estado = { indice: 0, respuestas: {}, resultado: null };

  const pantallas = {
    portada: $("[data-pantalla='portada']"),
    pregunta: $("[data-pantalla='pregunta']"),
    captura: $("[data-pantalla='captura']"),
    informe: $("[data-pantalla='informe']"),
  };

  function mostrar(nombre) {
    Object.keys(pantallas).forEach((k) => pantallas[k].classList.toggle("activa", k === nombre));
    window.scrollTo({ top: 0, behavior: "auto" });
    const foco = $("h1, h2, .t-h1, .t-h2", pantallas[nombre]);
    if (foco) { foco.setAttribute("tabindex", "-1"); foco.focus({ preventScroll: true }); }
  }

  /* Portada */
  function pintarPortada() {
    const p = pantallas.portada;
    $(".t-h1", p).textContent = T.PORTADA.titular;
    $(".t-sub", p).textContent = T.PORTADA.subtitular;
    $(".t-nota", p).textContent = T.PORTADA.nota;
    $(".t-aviso", p).textContent = T.PORTADA.aviso;
    $(".t-ayuda", p).textContent = T.CIERRE.ayuda;
    const b = $(".t-boton", p);
    b.textContent = T.PORTADA.boton;
    b.addEventListener("click", () => { estado.indice = 0; pintarPregunta(); mostrar("pregunta"); });
  }

  /* Preguntas */
  function pintarPregunta() {
    const p = pantallas.pregunta;
    const q = T.PREGUNTAS[estado.indice];
    const total = T.PREGUNTAS.length;
    $(".t-contador", p).textContent = (estado.indice + 1) + " / " + total;
    $(".t-progreso > span", p).style.width = Math.round((estado.indice / total) * 100) + "%";
    $(".t-h2", p).textContent = q.texto;

    const lista = $(".t-opciones", p);
    lista.innerHTML = "";
    q.opciones.forEach((o, i) => {
      const li = el("li");
      const b = el("button", "t-opcion", o.texto);
      b.type = "button";
      b.addEventListener("click", () => responder(i));
      li.appendChild(b);
      lista.appendChild(li);
    });

    const volver = $(".t-volver", p);
    volver.textContent = estado.indice === 0 ? "Volver al inicio" : "Pregunta anterior";
    volver.onclick = () => {
      if (estado.indice === 0) { mostrar("portada"); return; }
      estado.indice -= 1;
      pintarPregunta();
      mostrar("pregunta");
    };
  }

  function responder(i) {
    const q = T.PREGUNTAS[estado.indice];
    estado.respuestas[q.id] = i;
    if (estado.indice + 1 < T.PREGUNTAS.length) {
      estado.indice += 1;
      pintarPregunta();
      mostrar("pregunta");
    } else {
      estado.resultado = T.calcular(estado.respuestas);
      pintarCaptura();
      mostrar("captura");
    }
  }

  /* Captura */
  function pintarCaptura() {
    const p = pantallas.captura;
    $(".t-h2", p).textContent = T.CAPTURA.titular;
    $(".t-texto", p).textContent = T.CAPTURA.texto;
    $("label[for='t-nombre'] span", p).textContent = T.CAPTURA.campoNombre;
    $("label[for='t-email'] span", p).textContent = T.CAPTURA.campoEmail;
    $(".t-check-datos .t-check-texto", p).textContent = T.CAPTURA.consentimientoDatos + " ";
    $(".t-check-correos .t-check-texto", p).textContent = T.CAPTURA.consentimientoCorreos;
    $(".t-check-comercial .t-check-texto", p).textContent = T.CAPTURA.consentimientoComercial;
    $(".t-nota", p).textContent = T.CAPTURA.nota;
    $(".t-boton", p).textContent = T.CAPTURA.boton;

    const priv = $(".t-privacidad", p);
    if (T.CONFIG.privacidad && T.CONFIG.privacidad.url) {
      priv.href = T.CONFIG.privacidad.url;
      priv.hidden = false;
    } else {
      priv.hidden = true;
    }

    const form = $("form", p);
    form.onsubmit = async (e) => {
      e.preventDefault();
      const error = $(".t-error", p);
      const nombre = $("#t-nombre", p).value.trim();
      const email = $("#t-email", p).value.trim();
      const datos = $("#t-consent-datos", p).checked;
      const correos = $("#t-consent-correos", p).checked;
      const comercial = $("#t-consent-comercial", p).checked;

      if (!nombre) { error.textContent = "Dime cómo te llamas."; return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { error.textContent = "Ese email no parece correcto."; return; }
      if (!datos) { error.textContent = "Necesito tu permiso para usar tus respuestas y hacer el informe."; return; }
      const privacidadLista = T.CONFIG.privacidad && T.CONFIG.privacidad.url;
      if (!T.CONFIG.demo && !privacidadLista) { error.textContent = "Ahora mismo no se puede enviar. Vuelve a intentarlo más tarde."; return; }
      error.textContent = "";

      const boton = $(".t-boton", p);
      boton.disabled = true;
      let guardado = false;
      try {
        // Único punto de salida de datos. Sin CRM conectado, devuelve false y no envía nada.
        guardado = await T.enviarAlCRM({
          nombre, email, consentimientoDatos: datos, consentimientoCorreos: correos, consentimientoComercial: comercial,
          perfil: estado.resultado.perfil, evasion: estado.resultado.evasion,
          conciencia: estado.resultado.conciencia, ruta: estado.resultado.ruta,
          respuestas: estado.respuestas, fecha: new Date().toISOString(),
        });
      } catch (_) {
        guardado = false;
      }
      boton.disabled = false;
      if (!T.CONFIG.demo && !guardado) { error.textContent = "No se ha podido guardar. Inténtalo de nuevo."; return; }
      pintarInforme(nombre, comercial);
      mostrar("informe");
    };
  }

  /* Informe */
  function botonesDe(bloque) {
    const frag = document.createDocumentFragment();
    (bloque.botones || []).forEach((b, i) => {
      const url = T.CONFIG.urls[b.url];
      if (!url) return; // Sin URL, no se pinta.
      const a = el("a", "t-boton" + (i > 0 ? " t-boton-2" : ""), b.texto);
      a.href = url;
      frag.appendChild(a);
    });
    return frag;
  }

  function pintarInforme(nombre, comercial) {
    const p = pantallas.informe;
    const r = estado.resultado;
    const perfil = T.PERFILES[r.perfil];
    const evasion = T.EVASIONES[r.evasion];
    const conciencia = T.CONCIENCIA[r.conciencia];
    const paso = T.SIGUIENTE_PASO[r.ruta];
    const cont = $(".t-informe", p);
    cont.innerHTML = "";

    cont.appendChild(el("p", "t-etiqueta", "Tu informe, " + nombre));
    cont.appendChild(el("h2", "t-h1", perfil.nombre));
    cont.appendChild(el("p", "t-frase", perfil.frase));

    const bPerfil = el("div", "t-bloque");
    bPerfil.appendChild(el("h3", null, "Lo que tapas"));
    bPerfil.appendChild(el("p", null, perfil.texto));
    cont.appendChild(bPerfil);

    const bEvasion = el("div", "t-bloque");
    bEvasion.appendChild(el("h3", null, "Por dónde te escapas: " + evasion.nombre.toLowerCase()));
    bEvasion.appendChild(el("p", null, evasion.texto));
    cont.appendChild(bEvasion);

    const bConc = el("div", "t-bloque");
    bConc.appendChild(el("h3", null, conciencia.nombre));
    bConc.appendChild(el("p", null, conciencia.texto));
    cont.appendChild(bConc);

    cont.appendChild(el("p", "t-ayuda", T.CIERRE.ayuda));

    const mostrarPaso = !(r.ruta === "media" && T.CONFIG.mostrarRetoEnInforme === false);
    if (mostrarPaso) {
      const bPaso = el("div", "t-paso");
      bPaso.appendChild(el("h3", null, paso.titular));
      bPaso.appendChild(el("p", null, !comercial && paso.textoSinCorreos ? paso.textoSinCorreos : paso.texto));
      bPaso.appendChild(botonesDe(paso));
      if (paso.condiciones && T.CONFIG.urls[paso.condiciones.url]) {
        const c = el("a", "t-condiciones", paso.condiciones.texto);
        c.href = T.CONFIG.urls[paso.condiciones.url];
        c.target = "_blank";
        c.rel = "noopener";
        bPaso.appendChild(c);
      }
      cont.appendChild(bPaso);
    }

    cont.appendChild(el("p", "t-firma-final", "— " + T.CONFIG.firma));

    const cierre = el("div", "t-cierre");
    cierre.appendChild(el("p", null, T.CIERRE.aviso));
    cont.appendChild(cierre);
  }

  /* Arranque */
  raiz.querySelectorAll(".t-firma").forEach((n) => (n.textContent = T.CONFIG.firma));
  raiz.querySelectorAll(".t-minutos").forEach((n) => (n.textContent = T.CONFIG.minutos + " min"));
  pintarPortada();
  mostrar("portada");
})();
